export const getResponseSpeedColor = (speed: string) => {
  switch (speed) {
    case "Fast":
      return {
        backgroundColor: "#4cb04f",
        color: "white",
      };
    case "Moderate":
      return {
        backgroundColor: "#ffc108",
        color: "White",
      };
    case "Slow":
      return {
        backgroundColor: "#ff9900",
        color: "white",
      };
    case "Very Slow":
      return {
        backgroundColor: "#f54336",
        color: "white",
      };
    default:
      return {
        backgroundColor: "#e0e0e0",
        color: "black",
      };
  }
};

export const formatTime = (hours: number) => {
  if (!hours) return "-";
  const wholeHours = Math.floor(hours);
  const minutes = Math.round((hours - wholeHours) * 60);
  return `${wholeHours}h ${minutes}m`;
};

export const camelCaseToText = (camelCaseString: string) => {
  const result = camelCaseString.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};
